/**
 * @generated SignedSource<<1043f5dbef807ef1d1794fc56bb363a3>>
 * @relayHash 48d188b53dadf4628f1e10205a108aaa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 216fa5c0118b3930f52bc8f3d87c0a1efc90ca653cdb4b6f3156d32b2b03d7a9

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useListSubscriptions_issueUpdatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type useListSubscriptions_issueUpdatedSubscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useListSubscriptions_issueUpdatedSubscription = {
  response: useListSubscriptions_issueUpdatedSubscription$data;
  variables: useListSubscriptions_issueUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useListSubscriptions_issueUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useListSubscriptions_issueUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "216fa5c0118b3930f52bc8f3d87c0a1efc90ca653cdb4b6f3156d32b2b03d7a9",
    "metadata": {},
    "name": "useListSubscriptions_issueUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "dcd2c2ff534c8759baebc1f02e009c14";

export default node;
